import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import "./Stepline.css";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import { Steps } from "antd";
import Stepbarstep from "./Stepbarstep";
import { getAllStepperApplications } from "../../../HttpRequest/applyapplication";
const { Step } = Steps;

export default function Stepline(appId) {
  const userId = localStorage.getItem("id");
  const applicationId = appId.location.state.applicationDetails;

  const [stepLineStatus, setStepLineStatus] = useState({
    applicationId: "",
    country: "",
    intake: "",
    name: "",
    stepLineStatusDTOs: [],
    university: "",
    year: "",
  });
  useEffect(() => {
    getAllStepperApplications(userId, applicationId).then((data) => {
      console.log("data-->", data.data);
      setStepLineStatus((prevData) => ({
        ...prevData,
        ...data.data,
      }));
    });
    console.log("after data-->", stepLineStatus);
  }, []);
  const activeIndex = stepLineStatus.stepLineStatusDTOs.length - 1;
  const customDot = (dot, { status, index }) => {
    return dot;
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">Application Process</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>

                    <li className="breadcrumb-item active">
                      Application Process
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card card-table">
              <div className="card-body">
                <div className="card">
                  <Stepbarstep data={stepLineStatus} />
                </div>
                <hr></hr>
                <div className="row col-12">
                  <div className="chatgrop">
                    <Steps
                      direction="vertical"
                      progressDot={customDot}
                      current={activeIndex}
                    >
                      {stepLineStatus.stepLineStatusDTOs.map(
                        (status, index) => (
                          <Step
                            key={index}
                            title={status.status}
                            description={
                              <>
                                {index === 0 ? (
                                  <p>
                                    <strong>Created Date: </strong>
                                    {status.createdDate}
                                  </p>
                                ) : (
                                  <p>
                                    <strong>Updated Date: </strong>
                                    {status.createdDate}
                                  </p>
                                )}
                                <p>
                                  <strong>Status Changed By: </strong>
                                  {status.statusChangedBy}
                                </p>
                              </>
                            }
                          />
                        )
                      )}
                    </Steps>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
